import { createAction } from 'redux-actions';
export var VIDEO_CARDS_CLEANUP = 'WIDGET.VIDEO_CARDS.CLEANUP';
export var cleanupVideoCards = createAction(VIDEO_CARDS_CLEANUP);
